$(document).ready(() => {
  $('.upgrading-account').hide();

  $('.plan-upgrade-btn').on('click', () => {
    $('.upgrading-account').show();
    $('.plan-upgrade-modal .plan-details').hide();
    $('.plan-details #extra-charging').hide();
    $('.plan-details p.plan-credits').hide();
    $('.modal-footer.plan-info button[data-dismiss="modal"]').prop(
      'disabled',
      true,
    );
  });
});
